import { isAddressPopulated, validateLocationByMode } from 'shared/utils/address';
import type { TCoordinatesFields, TAddressFields } from 'components/trips/trip-create-task-modal/types';
import { ELocationMode } from 'components/trips/trip-create-task-modal/types';

export const validateCustomsForm = (
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
  loadingCustomAddress: TAddressFields,
  unloadingCustomAddress: TAddressFields,
  hasLoadingCustomAddressInCargos?: boolean,
  hasUnloadingCustomAddressInCargos?: boolean,
) => {
  if (locationMode === ELocationMode.loadingCustomAddress) {
    if (hasLoadingCustomAddressInCargos !== undefined) {
      return hasLoadingCustomAddressInCargos;
    }
    return isAddressPopulated(loadingCustomAddress);
  }

  if (locationMode === ELocationMode.unloadingCustomAddress) {
    if (hasUnloadingCustomAddressInCargos !== undefined) {
      return hasUnloadingCustomAddressInCargos;
    }
    return isAddressPopulated(unloadingCustomAddress);
  }

  return validateLocationByMode(locationMode, coordinates, address);
};
